"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMaskForType = void 0;
var react_imask_1 = require("react-imask");
var generateDateMask = function (locale) {
    if (locale === void 0) { locale = "pt-br"; }
    var dateString = locale === "en" ? "M/D/Y" : "D/M/Y";
    var mask = react_imask_1.IMask.createMask({
        mask: Date,
        pattern: dateString,
        blocks: {
            D: {
                mask: react_imask_1.IMask.MaskedRange,
                from: 1,
                to: 31,
                maxLength: 2,
            },
            M: {
                mask: react_imask_1.IMask.MaskedRange,
                from: 1,
                to: 12,
                maxLength: 2,
            },
            Y: {
                mask: react_imask_1.IMask.MaskedRange,
                from: 19000,
                to: 99990,
            },
        },
        parse: function (str) {
            var yearMonthDay = str.split("-");
            return new Date(parseInt(yearMonthDay[0]), parseInt(yearMonthDay[1]), -1, parseInt(yearMonthDay[2]));
        },
        lazy: true,
    });
    return mask;
};
var generateTimeMask = function (locale) {
    if (locale === void 0) { locale = "pt-br"; }
    var mask = react_imask_1.IMask.createMask({
        mask: "HH:MM:SS",
        blocks: {
            HH: {
                mask: react_imask_1.IMask.MaskedRange,
                from: 0,
                to: locale === "pt-br" ? 23 : 12,
                maxLength: 2,
            },
            MM: {
                mask: react_imask_1.IMask.MaskedRange,
                from: 0,
                to: 59,
                maxLength: 2,
            },
            SS: {
                mask: react_imask_1.IMask.MaskedRange,
                from: 0,
                to: 59,
                maxLength: 2,
            },
        },
        parse: function (str) {
            var hour = str.split(":")[0];
            var minute = str.split(":")[1];
            var second = str.split(":")[2];
            return new Date(0, 0, 0, parseInt(hour), parseInt(minute), parseInt(second));
        },
        lazy: true,
    });
    return mask;
};
var generateIntegerMask = function (locale) {
    if (locale === void 0) { locale = "pt-br"; }
    var mask = react_imask_1.IMask.createMask({
        mask: Number,
        lazy: true,
        thousandsSeparator: locale === "pt-br" ? "." : ",",
        radix: locale === "pt-br" ? "," : ".",
        mapToRadix: [locale === "pt-br" ? "," : "."],
        normalizeZeros: true,
        scale: 0,
        parse: function (str) {
            return parseInt(str.replace(/\D/g, ""));
        },
    });
    return mask;
};
var generateDecimalMask = function (locale) {
    if (locale === void 0) { locale = "pt-br"; }
    var regex = locale === "pt-br" ? /^[0-9.]*,?[0-9]*$/ : /^[0-9.]*$/;
    var mask = react_imask_1.IMask.createMask({
        mask: String,
        resolve: function (value, decimalPlaces) {
            if (value === "" || !value)
                return "";
            if (value.match(regex)) {
                var originalValue = "".concat(value);
                if (value.indexOf(",") === -1)
                    value = value + ",";
                if (value.indexOf(".") !== -1)
                    value = value.split(".").join("");
                var parts = value.split(",");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                var result = "";
                if (parts[1] === "" && originalValue.indexOf(",") !== -1) {
                    parts[1] = ",";
                    result = parts.join("");
                }
                else if (originalValue.indexOf(",") !== -1) {
                    parts[1] = parts[1].substring(0, decimalPlaces || parts[1].length);
                    result = parts.join(",");
                }
                else {
                    result = parts.join("");
                }
                return result;
            }
            return undefined;
        },
        parse: function (str) {
            return parseFloat(str.split(".").join("").replace(",", "."));
        },
        lazy: true,
    });
    return mask;
};
var generateCurrencyMask = function (locale) {
    if (locale === void 0) { locale = "pt-br"; }
    var regex = locale === "pt-br" ? /^[0-9.]*,?[0-9]*$/ : /^[0-9.]*$/;
    var mask = react_imask_1.IMask.createMask({
        mask: Number,
        resolve: function (value, decimalPlaces) {
            value = value.replace(/\D*/, "");
            if (value === "" || !value)
                return "";
            if (value.match(regex)) {
                var originalValue = "".concat(value);
                if (value.indexOf(",") === -1)
                    value = value + ",";
                if (value.indexOf(".") !== -1)
                    value = value.split(".").join("");
                var parts = value.split(",");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                var result = "";
                if (parts[1] === "" && originalValue.indexOf(",") !== -1) {
                    parts[1] = ",";
                    result = parts.join("");
                }
                else if (originalValue.indexOf(",") !== -1) {
                    parts[1] = parts[1].substring(0, decimalPlaces || 2);
                    result = parts.join(",");
                }
                else {
                    result = parts.join("");
                }
                return locale === "pt-br" ? "R$ ".concat(result) : "$ ".concat(result);
            }
            return undefined;
        },
        parse: function (str) {
            return parseFloat(str.split(".").join("").replace(",", ".")).toFixed(2);
        },
        lazy: true,
    });
    return mask;
};
var generatePhoneMask = function (ddd, locale) {
    if (ddd === void 0) { ddd = false; }
    if (locale === void 0) { locale = "pt-br"; }
    var mask = react_imask_1.IMask.createMask({
        mask: locale === "pt-br"
            ? ddd
                ? "00 [9]0000-0000"
                : "[9]0000-0000"
            : ddd
                ? "+000 000-000-000"
                : "000-000-000",
        lazy: true,
        parse: function (str) {
            return str.replace(/\D/g, "");
        },
    });
    return mask;
};
var generateCEPMask = function () {
    var mask = react_imask_1.IMask.createMask({
        mask: "00.000-000",
        lazy: true,
        parse: function (str) {
            return str.replace(/\D/g, "");
        },
    });
    return mask;
};
var generateCPFMask = function () {
    var mask = react_imask_1.IMask.createMask({
        mask: "000.000.000-00",
        lazy: true,
        parse: function (str) {
            return str.replace(/\D/g, "");
        },
    });
    return mask;
};
var generateCNPJMask = function () {
    var mask = react_imask_1.IMask.createMask({
        mask: "00.000.000/0000-00",
        lazy: true,
        parse: function (str) {
            return str.replace(/\D/g, "");
        },
    });
    return mask;
};
var generateMaskForType = function (type) {
    switch (type) {
        case "date": {
            return generateDateMask();
        }
        case "br-cpf": {
            return generateCPFMask();
        }
        case "br-cnpj": {
            return generateCNPJMask();
        }
        case "time": {
            return generateTimeMask();
        }
        case "integer": {
            return generateIntegerMask();
        }
        case "decimal": {
            return generateDecimalMask();
        }
        case "currency": {
            return generateCurrencyMask();
        }
        case "br-telefone": {
            return generatePhoneMask(true);
        }
        case "br-telefone-ddd": {
            return generatePhoneMask();
        }
        case "br-cep": {
            return generateCEPMask();
        }
        default: {
            return react_imask_1.IMask.createMask({
                mask: /.+/,
            });
        }
    }
};
exports.generateMaskForType = generateMaskForType;
